/**
 * @fileoverview Utilities to resolve available chat state transitions.
 */

export const AllowedStateIdsByStatus = {
  0: [0, 1, 2, 3], // new
  1: [1, 2, 3], // open
  2: [2, 3], // pending
  3: [3, 2] // resolved
};

export const getCommonAllowedStateIds = (statusValues = []) => {
  if (!Array.isArray(statusValues) || statusValues.length === 0) return [];

  return statusValues
    .map((statusValue) => AllowedStateIdsByStatus[Number(statusValue)] || [])
    .reduce((accumulator, allowedStateIds) => accumulator.filter((stateId) => allowedStateIds.includes(stateId)));
};

export const isStateOptionDisabled = (statusValues = [], stateId) => (
  Array.isArray(statusValues) && statusValues.length > 0
    ? statusValues.every((statusValue) => Number(statusValue) === Number(stateId))
    : false
);
